import create from 'zustand'

type UploadingInvoiceStoreActions = {
  invoiceIds: Set<number>
  addInvoiceId: (id: number) => void
  removeInvoiceId: (id: number) => void
}

export const useUploadingInvoiceStore = create<UploadingInvoiceStoreActions>((set, get) => ({
  invoiceIds: new Set(),

  addInvoiceId: id => {
    set(state => {
      const updatedSet = new Set(state.invoiceIds)
      updatedSet.add(id)
      return { invoiceIds: updatedSet }
    })
  },

  removeInvoiceId: id => {
    set(state => {
      const updatedSet = new Set(state.invoiceIds)
      updatedSet.delete(id)
      return { invoiceIds: updatedSet }
    })
  },
}))
